import defaultAxios from 'axios';
import type { AxiosResponse } from 'axios';
import {
  TYPESENSE_APIKEY,
  TYPESENSE_CONFIG,
  TYPESENSE_HOST,
  TYPESENSE_HOSTS,
} from '../constants/constants';

function typesenseFirstResultHasError(response: AxiosResponse): boolean {
  const r0 = response?.data?.results?.[0];
  return !!(r0?.code && r0.code !== 200 && r0.error);
}

/** Rotates which Typesense node is tried first on each call (round-robin). */
let typesenseHostRoundRobin = 0;

/**
 * POST to Typesense multi_search. Each request starts on the next host in rotation,
 * then falls through to the remaining hosts on network failure or first-result API errors.
 */
export async function postTypesenseMultiSearch(
  body: object,
  extraQueryParams = ''
): Promise<AxiosResponse> {
  let lastError: unknown;
  const n = TYPESENSE_HOSTS.length;
  const start = typesenseHostRoundRobin++ % n;

  for (let i = 0; i < n; i++) {
    const host = TYPESENSE_HOSTS[(start + i) % n];
    const isLastHost = i === n - 1;
    try {
      const url = `https://${host}/multi_search?x-typesense-api-key=${TYPESENSE_APIKEY}${extraQueryParams}`;
      const response = await defaultAxios.post(url, body, TYPESENSE_CONFIG);
      if (typesenseFirstResultHasError(response) && !isLastHost) {
        continue;
      }
      return response;
    } catch (e) {
      lastError = e;
      if (!isLastHost) {
        continue;
      }
      throw e;
    }
  }

  throw lastError ?? new Error('Typesense multi_search failed on all hosts');
}


export async function postTypesenseMultiSearchLoadBalanced(
  body: object,
  extraQueryParams = ''
): Promise<AxiosResponse> {
  try {
    const url = `https://${TYPESENSE_HOST}/multi_search?x-typesense-api-key=${TYPESENSE_APIKEY}${extraQueryParams}`;
    const response = await defaultAxios.post(url, body, TYPESENSE_CONFIG);
    return response;
  } catch (e) {
    console.error(e);
    throw e;
  }
}
